import IconMaestro from '../../assets/imgs/existing-payments/IconMaestro';
import IconMasterCard from '../../assets/imgs/existing-payments/IconMasterCard';
import IconNotDefined from '../../assets/imgs/existing-payments/IconNotDefined';
import IconVisa from '../../assets/imgs/existing-payments/IconVisa';

export const findCardType = (paymentCard: any) => {
  if (isMastercard(paymentCard)) {
    return <IconMasterCard />;
  } if (isMaestro(paymentCard)) {
    return <IconMaestro />;
  } if (isVisa(paymentCard)) {
    return <IconVisa />;
  }
  return <IconNotDefined />;
};

const isMastercard = (paymentCard: any): boolean => {
  let match: boolean = false;

  const masterCardStartWith = [51, 52, 53, 54, 55];
  const masterCardStarRange = 222100;
  const masterCardEndRange = 272099;

  if (
    Number(paymentCard.toString().substring(0, 6)) <= masterCardEndRange
    && Number(paymentCard.toString().substring(0, 6)) >= masterCardStarRange
  ) {
    return true;
  }
  masterCardStartWith.forEach((startWithElem) => {
    if (paymentCard.toString().startsWith(startWithElem.toString())) {
      match = true;
    }
  });

  return match;
};
const isMaestro = (paymentCard: any): boolean => {
  let match: boolean = false;

  const maestroCardStartWith = [
    5018, 5020, 5038, 5893, 6304, 6759, 6761, 6762, 6763,
  ];

  maestroCardStartWith.forEach((startWithElem) => {
    if (paymentCard.toString().startsWith(startWithElem.toString())) {
      match = true;
    }
  });

  return match;
};

const isVisa = (paymentCard: any): boolean => paymentCard.toString().startsWith('4');
